<template>
<div class="qc-navbar">
  <nav class=" navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a v-if="is_next_tracker" class="navbar-item" href="https://sensehawk.nextracker.com">
        <img
          class="qc-navbar__logo"  
          src="https://www.sensehawk.nextracker.com/img/logo.png"
        >
      </a>
      <a v-else class="navbar-item" href="https://sensehawk.com">
        <img
          class="qc-navbar__logo"  
          src="https://www.sensehawk.com/img/logo.png"
        >
      </a>
      <a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
  </nav>
</div>
</template>
<script>
export default {
  computed: {
      is_next_tracker() {
        return process.env.VUE_APP_ENV === "nxt";
      },
  },
};
</script>
<style lang="scss" >
.qc-navbar{
    .navbar{
    background-color: black;
    }
    &__logo{
        height: 40px;
    }
}
</style>

